import { render, staticRenderFns } from "./MainFormAuth.vue?vue&type=template&id=c198c788&"
import script from "./MainFormAuth.vue?vue&type=script&lang=js&"
export * from "./MainFormAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../var/www/pulse/pulse_client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports